export class FeePayerError extends Error {
	public readonly cause?: unknown;

	constructor(
		message = 'Fee payer failed to sign transaction.',
		cause?: unknown
	) {
		super(message);
		this.name = 'FeePayerError';
		this.cause = cause;
	}
}
